<template>
  <app-board class="m-0 p-0">
    <h4 class="mb-2 pl-3 pt-3">RTPs List</h4>

    <div class="row pl-3 pr-3">
      <div class="col-12 col-md-4 m-0">
        <dg-text-field
            :field_span="22"
            :label_span="22"
            :liveUpdate="true"
            @amUpdated="userSearchUpdated"
            field_mark=""
            placeholder="search destination"></dg-text-field>
      </div>
      <div class="col-12 col-md-8">
        <pagination
            :currentPage="currentPage"
            :navigateHandler="navigateToPage"
            :page-count="getPagesCount()"
            paginateClass=""></pagination>
      </div>
    </div>

    <module-list-layout :createAction="createAction" :header="false" :module="module" class="">
      <el-dialog :visible.sync="dialogVisible" title="" top="5vh" width="75%">
        <moduleForm
            :bindingForView="true"
            :dataToBind="dataToBind"
            :edit-mode="editMode"
            :on-create-callback="afterCreate"
            :on-edit-callback="afterEdit"
            v-if="dialogVisible"></moduleForm>
      </el-dialog>

      <app-ag-grid :agGrid="agGrid"></app-ag-grid>
    </module-list-layout>
  </app-board>
</template>

<script>

import actionsCell from './ag-grid/ActionsCell'
import module from './../index.js'
import {notify} from '@/system-services/notify.js'


export default {
  watch: {
    searchMe: function (val) {
      this.agGrid.gridApi.setQuickFilter(val);
    }
  },
  components: {
    pagination: () => import('@/components/pagination/View.vue'),
    moduleForm: () => import('./../form/View'),
    moduleListLayout: () => import('@/modules-config/layouts/list/View.vue')
  },
  data () {
    return {
      recordsCounter: 0,
      pageChunkSize: 20,
      userSearch: '',
      currentPage: 1,
      searchMe: null,
      module: {
        ...module
      },
      editMode: false,
      dialogVisible: false,
      rowsCounter: 0,
      dataToBind: null,
      rowToEdit: null,
      agGrid: {
        pagination: false,
        enableRtl: this.$langConfig.dir == 'rtl',
        agGridStyle: 'width: 100%; height: 650px; padding: 0',
        agGridClass: 'ag-theme-material',
        gridOptions: {
          suppressCellSelection: true,
          onGridReady: function (params) {
            setTimeout(() => {
              params.api.sizeColumnsToFit()
            }, 200)
          }
        },
        columnDefs: [
          {
            field: 'destination',
            headerName: "Destination",
            autoHeight: true,
            headerClass: this.$langConfig.cssClass
          },
          {
            field: 'vendor',
            headerName: 'Vendor',
            autoHeight: true,
            headerClass: this.$langConfig.cssClass
          },
          {
            width: 100,
            field: 'rtp',
            headerName: 'RTP',
            autoHeight: true,
            headerClass: this.$langConfig.cssClass
          },
          /*{
            width: 80,
            headerName: 'Actions',
            headerClass: this.$langConfig.cssClass,
            cellRendererFramework: $vue.extend(actionsCell),
            cellRendererParams: {
              props: {
                actionsHandler: this.actionsHandler
              }
            }
          }*/
        ],
        rowData: []
      }
    };
  },
  beforeMount () {

    this.currentPage = parseInt(this.$route.params.listPage)
    this.getEntityListData(this.currentPage)

    /*this.$store.dispatch(this.module.info.name + '-api/list').then(response => {
      this.agGrid.rowData = response;
      console.log(response[0])
      this.rowsCounter = response.length;
    })*/
  },
  methods: {
    ...$mapActions('voip-rtp-finder-api', {getEntityList: 'list'}),
    buildAgGridData(response) {
      this.agGrid.rowData = response.rows;
      this.recordsCounter = response.count;
      this.amReady = true
    },
    getEntityListData(page) {
      this.getEntityList({page: page, search: this.userSearch}).then(response => {
        this.buildAgGridData(response)
      })
      this.currentPage = page
    },
    userSearchUpdated(field) {
      let val = field.field.field_value
      this.userSearch = val
      clearTimeout(this.userSearchTimeOut)
      this.userSearchTimeOut = setTimeout(() => {
        this.getEntityListData(1) //this.agGrid.gridApi.setQuickFilter(val);
      }, 200)
    },
    getPagesCount () {
      return Math.ceil(this.recordsCounter / this.pageChunkSize)
    },
    navigateToPage (page) {
      $router.push({name : 'module->voip-rtp-finder->panel->page', params: {listPage: page}})
    },
    refreshGrid() {
      this.agGrid.gridOptions.api.setRowData(this.agGrid.rowData)
    },
    afterEdit(updatedData) {
      // getting a rowNode by index
      // this.agGrid.gridApi.getDisplayedRowAtIndex(0).setData({})

      this.agGrid.rowData[this.rowToEdit] = updatedData;
      this.dialogVisible = false;
      this.refreshGrid();
    },
    afterCreate(newEntity) {
      this.agGrid.rowData.push(newEntity);
      this.dialogVisible = false;
      this.refreshGrid();
    },
    createAction(params) {
      this.dialogVisible = true;
      this.editMode = false;
      this.dataToBind = null;
      this.rowToEdit = null;
      // this.$router.push({ name: 'esb-individual-teacher-view', params: { teacherId: params.data.id}})
    },
    editAction(params) {
      this.dialogVisible = true;
      this.editMode = true;
      this.dataToBind = params.data;
      this.rowToEdit = params.rowIndex;
      // this.$router.push({ name: 'esb-individual-teacher-view', params: { teacherId: params.data.id}})
    },
    removeAction(params) {
      this.$store.dispatch(this.module.info.name + '-api/remove', {id: params.data.id}).then(response => {
        this.agGrid.rowData.splice(params.rowIndex, 1);
        this.refreshGrid();
        this.rowsCounter -= 1;
        notify({
          type: 'success',
          title: this.$ml.get('deleted'),
        });
      })
    },
    actionsHandler(command, params) {
      this[command](params)
    }
  }
}
</script>
